var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditNoteFill1Wght400Grad0Opsz40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 28.5",
    style: {
      enableBackground: "new 0 0 34 28.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3b454e}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,27.3v-3.2l8.8-8.8l3.2,3.2l-8.8,8.8H18.1z M4.1,20.7v-2.8h12.2v2.8H4.1z M31.7,16.9l-3.2-3.2l1.2-1.2 c0.3-0.3,0.6-0.4,1-0.4s0.7,0.1,1,0.4l1.2,1.2c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1L31.7,16.9z M4.1,13.9v-2.8h19.2v2.8H4.1z  M4.1,7.1V4.3h19.2v2.8H4.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoteFill1Wght400Grad0Opsz40);
export default __webpack_public_path__ + "static/media/edit_note_FILL1_wght400_GRAD0_opsz40.2ccf2bb3b2bcbd5e1cda2db4d14846f4.svg";
export { ForwardRef as ReactComponent };